import * as firebase from 'firebase';

import Base from './Base';
import AuthorizationApi from './Authorization';
import { store } from '../App';
import PopupConfirmation from '../Shared/Popup/Confirmation';

import { fbDataPurifier } from '../utils';

const Status = {
  ...Base.Status,
  CREATED: 'CREATED',
  UPDATED: 'UPDATED',
  DEACTIVATED: 'DEACTIVATED',
};

const getDriverRef = (client, driverId) => firebase.database().ref(`/clients/${client}/driver/drivers/${driverId}/`);
const getNewDriverRef = client => firebase.database().ref(`/clients/${client}/driver/drivers/`).push();
const getDriverTrashRef = (client, driverId) => firebase.database().ref(`/clients/${client}/trash/drivers/${driverId}/`);

async function create(props) {
  const { currentUser: { client } } = store.getState().authState;

  if (AuthorizationApi.cannot(AuthorizationApi.Actions.CREATE)) {
    return Base.respondAndNotifyWithDenied();
  }

  try {
    await getNewDriverRef(client).update(fbDataPurifier(props));
    return {
      status: Status.CREATED,
    };
  } catch (error) {
    return Base.respondAndNotifyWithFailure(error);
  }
}

async function update(id, props) {
  const { currentUser: { client } } = store.getState().authState;

  if (AuthorizationApi.cannot(AuthorizationApi.Actions.UPDATE)) {
    return Base.respondAndNotifyWithDenied();
  }

  try {
    await getDriverRef(client, id).update(fbDataPurifier(props));
    return {
      status: Status.UPDATED,
    };
  } catch (error) {
    return Base.respondAndNotifyWithFailure(error);
  }
}

async function updateOrCreateById(id = null, props) {
  if (!id) {
    return create(props);
  }

  return update(id, props);
}

async function deactivate(id) {
  const { currentUser: { client } } = store.getState().authState;

  if (AuthorizationApi.cannot(AuthorizationApi.Actions.DELETE)) {
    return Base.respondAndNotifyWithDenied();
  }

  try {
    const driverRef = getDriverRef(client, id);
    const driverTrashRef = getDriverTrashRef(client, id);

    const driver = (await driverRef.once('value')).val();

    const isConfirmed = await PopupConfirmation.show(`Desativar motorista: ${driver.firstName} ${driver.surname}`);
    if (!isConfirmed) {
      return { status: Status.SKIPPED };
    }

    await driverTrashRef.set(driver);
    await driverRef.remove();

    return { status: Status.DEACTIVATED };
  } catch (error) {
    return Base.respondAndNotifyWithFailure(error);
  }
}

export default {
  Status,
  create,
  update,
  updateOrCreateById,
  deactivate,
};



// WEBPACK FOOTER //
// ./src/Api/Drivers.js